var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grey lighten-5" },
    [
      _c(
        "div",
        { staticClass: "d-flex", attrs: { id: "ai_container" } },
        [
          _c(
            "v-navigation-drawer",
            {
              attrs: { app: "", width: _vm.isMobilePort ? "70%" : 280 },
              model: {
                value: _vm.sidebarVisible,
                callback: function ($$v) {
                  _vm.sidebarVisible = $$v
                },
                expression: "sidebarVisible",
              },
            },
            [
              _c("ai-navigator-sidebar", {
                staticClass: "fill-height py-4",
                attrs: { groupedDates: _vm.groupedDates, id: "ai_right" },
                on: { loadConversations: _vm.loadConversations },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-grow-1 grey lighten-5",
              class: _vm.isMobileAndTablet ? "pa-3" : "",
              attrs: { id: "main_content content-container" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column h-full",
                  staticStyle: { "max-width": "960px", margin: "0 auto" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-grow-1 overflow-auto pr-1 pr-lg-3",
                      attrs: { id: "msg_rows" },
                    },
                    [
                      _vm.isNewChatMode
                        ? _c("ai-navigator-start", {
                            attrs: {
                              "can-send-messages": !_vm.isQuestionLimitReached,
                            },
                            on: { "question-clicked": _vm.onQuestionClicked },
                          })
                        : _vm._l(
                            _vm.visibleConversations,
                            function (conversation, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "msg_item" },
                                [
                                  _c("divider-with-text", {
                                    attrs: {
                                      text: _vm.formatContextForDividerText(
                                        conversation
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "chat-message",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { type: "user" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(conversation.question) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  conversation.live
                                    ? _c("chat-server-message", {
                                        staticClass: "mb-5",
                                        attrs: { prompt: conversation },
                                      })
                                    : conversation.response
                                    ? _c(
                                        "chat-message",
                                        {
                                          staticClass: "mb-3",
                                          attrs: { type: "system" },
                                        },
                                        [
                                          _c("chat-question-response", {
                                            attrs: {
                                              response: conversation.response,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { id: "input_box" } },
                    [
                      _c("question-limit-alert", {
                        attrs: {
                          countdownremaining: _vm.countdownremaining,
                          "countdown-reset": _vm.countdownReset,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-space-between align-center mb-1 text-muted",
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm.codeCyclesLoading
                                ? _c("v-progress-linear", {
                                    staticStyle: { "min-width": "10em" },
                                    attrs: {
                                      active: true,
                                      color: "primary",
                                      indeterminate: "",
                                    },
                                  })
                                : _vm.codeCyclesError
                                ? _c("p", { staticClass: "red--text mb-0" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.codeCyclesError) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm.selectedLocation && _vm.selectedYear
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center text-sm pa-1",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-no-wrap" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.selectedLocation) +
                                              " • " +
                                              _vm._s(_vm.selectedYear) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isMobileAndTablet
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { text: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.sidebarVisible = true
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-tune"),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-textarea", {
                        staticClass: "white",
                        attrs: {
                          label: "Enter question",
                          "hide-details": "",
                          outlined: "",
                          rows: "1",
                          counter: "true",
                          autocomplete: "off",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.onEnterClicked.apply(null, arguments)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [
                                _vm.isBusy
                                  ? _c("v-progress-circular", {
                                      staticClass: "disabled-icon",
                                      attrs: {
                                        indeterminate: "",
                                        color: "grey",
                                        size: "28",
                                      },
                                    })
                                  : _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "primary",
                                          "aria-label": "Send question",
                                        },
                                        on: { click: _vm.sendMessage },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-send-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.question,
                          callback: function ($$v) {
                            _vm.question = $$v
                          },
                          expression: "question",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c("p", { staticClass: "mb-0" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "caption text--secondary mb-0" },
                            [
                              _vm._v(
                                _vm._s(_vm.currentCharCount) +
                                  " / " +
                                  _vm._s(_vm.maxCharCount) +
                                  " chars"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-terms-dialog", {
        attrs: {
          visible: _vm.disclaimerModalVisible,
          "can-be-closed": !_vm.disclaimerConfirmationRequired,
        },
        on: {
          closed: function ($event) {
            _vm.disclaimerModalVisible = false
          },
          confirmed: _vm.disclaimerConfirmed,
        },
      }),
      _vm._v(" "),
      _c("notes"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }